import { createStore, useStore } from 'src/utils/createStore';
import { readStoredItem, removeStoredItem, writeStoredItem } from 'src/utils/storageManager';
import { toDayKey } from 'src/utils/date';

const STORAGE_PREFIX = 'streak-day-recorded';

const storageKey = (userId: number) => `${STORAGE_PREFIX}:${userId}`;

const recordedFor = createStore<number | null>(null);

const readStamp = (userId: number): string | null =>
  readStoredItem(storageKey(userId));

const writeStamp = (userId: number): boolean =>
  writeStoredItem(storageKey(userId), toDayKey());

const isRecordedFor = (userId: number | undefined): boolean => {
  if (userId === undefined) return false;
  if (recordedFor.getState() === userId) return true;
  return readStamp(userId) === toDayKey();
};

export const markStreakDayRecorded = (userId: number | undefined) => {
  if (userId === undefined) return;
  writeStamp(userId);
  recordedFor.setState(userId);
};

export const resetStreakDayRecorded = (userId?: number) => {
  recordedFor.setState(null);
  if (userId !== undefined) removeStoredItem(storageKey(userId));
};

export const useStreakDayRecorded = (userId: number | undefined): boolean =>
  useStore(recordedFor, () => isRecordedFor(userId));
